import React, { useEffect, useRef, useState } from "react";
import ProfitCss from "./style";

const Profits = () => {
  const paraRef = useRef();
  const [visible, setVisible] = useState(false);
  const observer = React.useRef(
    new IntersectionObserver(
      (enteries, ob) => {
        enteries.forEach(entry => {
          if (entry.isIntersecting) setVisible(true);
        });
      },
      { root: null, rootMargin: "-200px 0px", threshold: 0 }
    )
  );
  useEffect(() => {
    observer.current.observe(paraRef.current);
  }, []);

  let classes = "title";
  if (visible) {
    classes += " fadeIn";
  }
  return (
    <ProfitCss>
      <div className="wrapper">
        <div className={classes} ref={paraRef}>
          One Token, Eight Ways to Profit
        </div>
        <div className="content">
          <div className="image">
            <img src="elephant.png" alt="ele_Image" />
          </div>
          <div className="profits_div">
            <div className="profits">
              <div className="profit">
                <div className="profit_title">Rewards</div>
                <div className="profit_text">
                  Every buy, sell, or transfer, 6% gets shared with ALL
                  tokenholders
                </div>
              </div>
              <div className="profit">
                <div className="profit_title">Airdrops</div>
                <div className="profit_text">
                  100K CEFA shared among our holders, every 30 days for 20 years
                </div>
              </div>
              <div className="profit">
                <div className="profit_title">Bonds</div>
                <div className="profit_text">
                  Upcoming investment instrument that shares locked 150K CEFA
                  pool every 90 days for 20 years, distributed proportionally as
                  CETO, BCETO, ECETO
                </div>
              </div>
              <div className="profit">
                <div className="profit_title">Holding</div>
                <div className="profit_text">
                  The more volume in CEFA, the higher the price for CEFA and
                  B/E/CETO
                </div>
              </div>
            </div>
            <div className="profits">
              <div className="profit">
                <div className="profit_title">Dividends</div>
                <div className="profit_text">
                  Every buy, sell, or transfer, ~1% gets shared with ALL
                  tokenholders in the CETO Blockchain Family (B/E/CETO)
                </div>
              </div>
              <div className="profit">
                <div className="profit_title">Farming</div>
                <div className="profit_text">
                  1M CEFA every 90 days (4M total) in yield farming to give you
                  a safe staking place to earn APY gains in BNB
                </div>
              </div>
              <div className="profit">
                <div className="profit_title">Fertilizer</div>
                <div className="profit_text">
                  A 1.2% burn on every transaction through reflection rewards
                  creates a continuously reducing supply and higher price
                </div>
              </div>
              <div className="profit">
                <div className="profit_title">Product</div>
                <div className="profit_text">
                  Use CEFA with all forthcoming BCETO games and products
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="content_mobile">
          <div className="profits">
            <div className="profit">
              <div className="profit_title">Rewards</div>
              <div className="profit_text">
                Every buy, sell, or transfer, 6% gets shared with ALL
                tokenholders
              </div>
            </div>
            <div className="profit">
              <div className="profit_title">Airdrops</div>
              <div className="profit_text">
                100K CEFA shared among our holders, every 30 days for 20 years
              </div>
            </div>
          </div>
          <div className="profits">
            <div className="profit">
              <div className="profit_title">Bonds</div>
              <div className="profit_text">
                Upcoming investment instrument that shares locked 150K CEFA pool
                every 90 days for 20 years, distributed proportionally as CETO,
                BCETO, ECETO
              </div>
            </div>
            <div className="profit">
              <div className="profit_title">Holding</div>
              <div className="profit_text">
                The more volume in CEFA, the higher the price for CEFA and
                B/E/CETO
              </div>
            </div>
          </div>
          <div className="profits">
            <div className="profit">
              <div className="profit_title">Dividends</div>
              <div className="profit_text">
                Every buy, sell, or transfer, ~1% gets shared with ALL
                tokenholders in the CETO Blockchain Family (B/E/CETO)
              </div>
            </div>
            <div className="profit">
              <div className="profit_title">Farming</div>
              <div className="profit_text">
                1M CEFA every 90 days (4M total) in yield farming to give you a
                safe staking place to earn APY gains in BNB
              </div>
            </div>
          </div>
          <div className="profits">
            <div className="profit">
              <div className="profit_title">Fertilizer</div>
              <div className="profit_text">
                A 1.2% burn on every transaction through reflection rewards
                creates a continuously reducing supply and higher price
              </div>
            </div>
            <div className="profit">
              <div className="profit_title">Product</div>
              <div className="profit_text">
                Use CEFA with all forthcoming BCETO games and products
              </div>
            </div>
          </div>
        </div>
      </div>
    </ProfitCss>
  );
};

export default Profits;
